import { shouldPlayIntro } from './homeIntro.js';

// Store interval/timeout IDs globally so we can clear them
let slideshowInterval = null;
let slideshowStartTimeout = null;

// Auto-fading slideshow for homepage
export function initHomeSlideshow() {
  const logoSecondLine = document.querySelector('.logo__line--second');

  // Clear any existing intervals/timeouts from previous page loads
  if (slideshowInterval) {
    clearInterval(slideshowInterval);
    slideshowInterval = null;
  }
  if (slideshowStartTimeout) {
    clearTimeout(slideshowStartTimeout);
    slideshowStartTimeout = null;
  }

  // Reset logo to "Architects" when not on home page
  if (!document.body.classList.contains('home')) {
    if (logoSecondLine) {
      logoSecondLine.textContent = 'Architects';
      logoSecondLine.style.opacity = '1';
    }
    return;
  }

  const slides = document.querySelectorAll('.home-slide');

  if (slides.length === 0) {
    return;
  }

  let currentIndex = 0;
  const fadeDuration = 1000; // 1s fade
  const displayDuration = 4000; // 4s display time
  // Delay before the slideshow starts cycling. When the full intro plays,
  // wait for grid + logo animation to finish. Otherwise hold the SSR
  // "Architects" title for one display duration so it's actually seen.
  const introDelay = shouldPlayIntro() ? 5000 : displayDuration;

  // Ensure first slide is visible immediately
  slides[0].classList.add('active');

  // Get cycling titles from data attribute.
  // Start at -1 so the first cycleTitle() call lands on cyclingTitles[0]
  // (the SSR logo starts as "Architects" to match the intro overlay).
  let cyclingTitles = [];
  let titleIndex = -1;

  if (logoSecondLine && logoSecondLine.dataset.cyclingTitles) {
    try {
      cyclingTitles = JSON.parse(logoSecondLine.dataset.cyclingTitles);
    } catch (e) {
      console.error('Error parsing cycling titles:', e);
    }
  }

  function showSlide(index) {
    // Fade out current slide
    slides[currentIndex].classList.remove('active');

    // Update index
    currentIndex = index;

    // Fade in new slide
    slides[currentIndex].classList.add('active');
  }

  function cycleTitle() {
    if (cyclingTitles.length > 0 && logoSecondLine) {
      // Fade out
      logoSecondLine.style.opacity = '0';

      setTimeout(() => {
        // Change text
        titleIndex = (titleIndex + 1) % cyclingTitles.length;
        logoSecondLine.textContent = cyclingTitles[titleIndex];

        // Fade in
        logoSecondLine.style.opacity = '1';
      }, 300); // Wait for fade out
    }
  }

  function nextSlide() {
    const nextIndex = (currentIndex + 1) % slides.length;
    showSlide(nextIndex);
    // Keep the logo title in sync with slide changes
    cycleTitle();
  }

  // Wait for the intro animation to finish so slide 1 is actually on-screen
  // for its full display duration before cycling to slide 2. The first title
  // change is triggered at the same moment the grid pattern gives way to the
  // first image, and then each subsequent change is driven by nextSlide().
  slideshowStartTimeout = setTimeout(() => {
    // Sync first title change with the pattern → image transition
    if (cyclingTitles.length > 1) {
      cycleTitle();
    }
    if (slides.length > 1) {
      slideshowInterval = setInterval(nextSlide, displayDuration + fadeDuration);
    }
    slideshowStartTimeout = null;
  }, introDelay);
}
